// ABOUTME: Nutrition details icon for viewing nutrition information
// ABOUTME: Drawn in currentColor — `color` when given, else black (`text-black`), the foreground in the dark theme

import { cn } from "@shared/lib/utils"

interface NutritionDetailsIconProps {
  className?: string
  size?: number
  color?: string
}

export const NutritionDetailsIcon = ({ className = "", size = 18, color }: NutritionDetailsIconProps) => (
  <svg
    width={size}
    height={Math.round((size * 14) / 18)}
    viewBox="0 0 18 14"
    fill="none"
    className={cn("text-black", className)}
    style={color ? { color } : undefined}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.875 0.125H2.125C1.79348 0.125 1.47554 0.256696 1.24112 0.491116C1.0067 0.725537 0.875 1.04348 0.875 1.375V12.625C0.875 12.9565 1.0067 13.2745 1.24112 13.5089C1.47554 13.7433 1.79348 13.875 2.125 13.875H15.875C16.2065 13.875 16.5245 13.7433 16.7589 13.5089C16.9933 13.2745 17.125 12.9565 17.125 12.625V1.375C17.125 1.04348 16.9933 0.725537 16.7589 0.491116C16.5245 0.256696 16.2065 0.125 15.875 0.125ZM15.875 12.625H2.125V1.375H15.875V12.625ZM13.375 4.5C13.375 4.66576 13.3092 4.82473 13.1919 4.94194C13.0747 5.05915 12.9158 5.125 12.75 5.125H5.25C5.08424 5.125 4.92527 5.05915 4.80806 4.94194C4.69085 4.82473 4.625 4.66576 4.625 4.5C4.625 4.33424 4.69085 4.17527 4.80806 4.05806C4.92527 3.94085 5.08424 3.875 5.25 3.875H12.75C12.9158 3.875 13.0747 3.94085 13.1919 4.05806C13.3092 4.17527 13.375 4.33424 13.375 4.5ZM13.375 7C13.375 7.16576 13.3092 7.32473 13.1919 7.44194C13.0747 7.55915 12.9158 7.625 12.75 7.625H5.25C5.08424 7.625 4.92527 7.55915 4.80806 7.44194C4.69085 7.32473 4.625 7.16576 4.625 7C4.625 6.83424 4.69085 6.67527 4.80806 6.55806C4.92527 6.44085 5.08424 6.375 5.25 6.375H12.75C12.9158 6.375 13.0747 6.44085 13.1919 6.55806C13.3092 6.67527 13.375 6.83424 13.375 7ZM13.375 9.5C13.375 9.66576 13.3092 9.82473 13.1919 9.94194C13.0747 10.0592 12.9158 10.125 12.75 10.125H5.25C5.08424 10.125 4.92527 10.0592 4.80806 9.94194C4.69085 9.82473 4.625 9.66576 4.625 9.5C4.625 9.33424 4.69085 9.17527 4.80806 9.05806C4.92527 8.94085 5.08424 8.875 5.25 8.875H12.75C12.9158 8.875 13.0747 8.94085 13.1919 9.05806C13.3092 9.17527 13.375 9.33424 13.375 9.5Z"
      fill="currentColor"
    />
  </svg>
)
